import { TextField, TextFieldProps } from '@mui/material'
import React from 'react'
import { Controller, RegisterOptions, useFormContext } from 'react-hook-form'
import { useTranslation } from '../../hooks'
import get from 'lodash/get'
import { BoxWithLabel } from '../BoxWithLabel'

export type TextfieldControllerProps = TextFieldProps & {
  name: string
  label?: string
  rules?: RegisterOptions
}

const FieldWithController: React.FC<TextfieldControllerProps> = ({
  name,
  rules,
  ...props
}) => {
  const { t } = useTranslation()

  const {
    formState: { errors },
    control,
  } = useFormContext()

  return (
    <Controller
      rules={{
        ...rules,
        required: rules?.required && t('messages:warnings.required'),
      }}
      render={({ field }) => (
        <TextField
          {...field}
          error={!!get(errors, name)}
          helperText={get(errors, [...name.split('.'), 'message']) as string}
          fullWidth
          {...props}
        />
      )}
      name={name}
      control={control}
    />
  )
}

const TextfieldController: React.FC<TextfieldControllerProps> = ({
  label,
  ...props
}) => {
  return label ? (
    <BoxWithLabel label={label} required={!!props.rules?.required}>
      <FieldWithController {...props} />
    </BoxWithLabel>
  ) : (
    <FieldWithController {...props} />
  )
}

export { TextfieldController }
